import React, { useEffect, useRef } from "react";

export interface ButtonProps {
    id: string,
    className: string,
    hh: number,
    rspacing: number,
    ordinal: number,
    onClick?: (buttonId:string) => void,
}

export const MainButton = ({id, className, hh, rspacing, ordinal, onClick}: ButtonProps) : React.JSX.Element => {
    const bref = useRef<HTMLButtonElement>(null);

    const onClickButton = () => {
        if(onClick !== undefined) {
            onClick(id);
        }
    }

    useEffect(() => {
        var bh = 2*(hh/3);
        if(bh < 30) bh = 30;
        const tgap = (hh-bh)/2;
        if(bref.current) {
            bref.current.style.top = tgap+'px';
            bref.current.style.width = bh+'px';
            bref.current.style.height = bh+'px';
            bref.current.style.right = ((ordinal-1)*bh+ordinal*rspacing)+'px';
        }
    }, [hh]);
    return (
        <button className={className} ref={bref} onClick={onClickButton} />
    );
}